module.exports = __webpack_public_path__ + "img/IMG_3323.50114dac.jpg";